import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ImpersonationBanner() {
  const [active, setActive]   = useState(false);
  const [name, setName]       = useState('');
  const [company, setCompany] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    function check() {
      const token = sessionStorage.getItem('awwt_imp_token');
      if (token) {
        setActive(true);
        setName(sessionStorage.getItem('awwt_imp_name') || '');
        setCompany(sessionStorage.getItem('awwt_imp_company') || '');
      } else {
        setActive(false);
      }
    }
    check();
    // re-check if another tab clears the token
    window.addEventListener('storage', check);
    return () => window.removeEventListener('storage', check);
  }, []);

  if (!active) return null;

  function exitImpersonation() {
    sessionStorage.removeItem('awwt_imp_token');
    sessionStorage.removeItem('awwt_imp_name');
    sessionStorage.removeItem('awwt_imp_company');
    sessionStorage.removeItem('awwt_imp_email');
    navigate('/admin/users');
  }

  const label = [name, company].filter(Boolean).join(' · ');

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: '#e65100',
      color: '#fff',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px 20px',
      fontSize: 13,
      fontWeight: 500,
      boxShadow: '0 2px 6px rgba(0,0,0,.25)',
    }}>
      <span>
        👁 Viewing as vendor: <strong>{label || 'Unknown vendor'}</strong>
      </span>
      <button
        onClick={exitImpersonation}
        style={{
          background: 'rgba(255,255,255,0.2)',
          color: '#fff',
          border: '1px solid rgba(255,255,255,0.5)',
          borderRadius: 4,
          padding: '4px 14px',
          cursor: 'pointer',
          fontWeight: 600,
          fontSize: 13,
        }}
      >
        ✕ Exit impersonation
      </button>
    </div>
  );
}
